import React, { Component } from "react";
import { generateRoomReport } from "../../services/montlyReportService";

import BlockUi from "react-block-ui";
import { Message } from "semantic-ui-react";
import auth from "../../services/authService";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReactToPrint from "react-to-print";
import MonthlRoomPrintReport from "./print/room";

class MonthlRoomReport extends Component {
  state = {
    startDate: new Date(),
    endDate: new Date(),
    transactions: [],
    showSalaryForm: false,
    showError: false,
    salaries: [],
  };

  handleChangeStartDate = (date) => {
    this.setState({
      startDate: date,
    });
  };

  handleChangeEndDate = (date) => {
    this.setState({
      endDate: date,
    });
  };

  doSubmit = async () => {
    try {
      var event = new Date(this.state.startDate);
      let startDate = JSON.stringify(event);
      startDate = startDate.slice(1, 11);

      event = new Date(this.state.endDate);
      let endDate = JSON.stringify(event);
      endDate = endDate.slice(1, 11);

      this.setState({ blocking: true });

      const verifyData = {
        startDate: startDate,
        endDate: endDate,
      };

      const res = await generateRoomReport(verifyData);

      if (res.data.proceed === "no") {
        this.setState({
          showError: true,
          showSalaryForm: false,
          blocking: false,
        });
      } else {
        this.setState({
          showError: false,
          showSalaryForm: true,
          blocking: false,
          transactions: res.data,
        });
      }
    } catch (ex) {
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        if (ex.response.data.errors.name)
          errors.name = ex.response.data.errors.name;

        this.setState({ errors, blocking: false });
        //toast.warning("check validation errors.");
      }
    }
  };

  render() {
    if (auth.getCurrentUser().role != "client") {
      return "Your are authorized to perform this action.";
    }
    const { transactions } = this.state;
    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <h1 className="container__heading">Room Monthly Report</h1>

        <div className="grid monthly-report-filters">
          <DatePicker
            selected={this.state.startDate}
            onChange={this.handleChangeStartDate}
            placeholderText="Select Start Date"
            className="input"
          />
          <div></div>
          <DatePicker
            selected={this.state.endDate}
            onChange={this.handleChangeEndDate}
            className="input"
            placeholderText="Select End Date"
          />
          <div></div>
          <button className="btn btn--primary" onClick={this.doSubmit}>
            Submit
          </button>
        </div>

        <div className="ui error form" style={{ width: "30%" }}>
          <Message
            negative
            style={{
              display: this.state.showError == true ? "block" : "none",
            }}
          >
            <Message.Header>Error</Message.Header>
            <p>Data not found for the dates specified.</p>
          </Message>
        </div>

        <div
          className="scrap-report"
          style={{
            display: this.state.showSalaryForm == true ? "block" : "none",
          }}
        >
          <div className="scrap-report__print">
            <ReactToPrint
              trigger={() => <a href="#">Print this out!</a>}
              content={() => this.componentRef}
            />
          </div>
          <MonthlRoomPrintReport
            transactions={transactions}
            ref={(el) => (this.componentRef = el)}
          />
          <br />
        </div>
      </BlockUi>
    );
  }
}

export default MonthlRoomReport;
